import React, {Component} from 'react';
import { Link } from 'react-router-dom';

class HomeStaticBanner1 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // menu:[],
        }
    }

    render() {
        const banner = this.props.banner || {};
        return (
            <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-12">
                                <div className="ps-promo__item ps-static-banner ps-static-banner--single">
                                    <div className="ps-static-banner__imageWrap">
                                        <img className="ps-promo__banner ps-static-banner__image" src={banner.image_path} alt={banner.image_title || 'Banner'} />
                                    </div>
                                </div>
                            </div>
                        </div>
            </div>

        );
    }
}

export default HomeStaticBanner1;
